import React from 'react';
import PromotionList from 'components/Content/PromotionList/PromotionList';
import PromoListFallback from 'components/Bcc/BccRwdPersonalizedPromoList/PromoListFallback';
import { wrapFunctionalComponent } from 'utils/framework';

const PromotionListForYouHandler = ({ showFallback, user, ...restProps }) => {
    if (showFallback) {
        return (
            <PromoListFallback
                isSkeleton={restProps.showSkeleton}
                isAnonymous={user.isAnonymous}
                enablePageRenderTracking={restProps.enablePageRenderTracking}
                sid={restProps.sid}
                title={restProps.title}
                personalization={restProps.personalization}
                extraSotFields={restProps.extraSotFields}
                clientRequestId={restProps.clientRequestId}
                user={user}
            />
        );
    }

    return <PromotionList {...restProps} />;
};

export default wrapFunctionalComponent(PromotionListForYouHandler, 'PromotionListForYouHandler');
